import React from "react";

import PlanItems from "components/PlanItems";

interface PlanData {
  id: string;
  name: string;
  description: string;
  provides: string[];
  cost_ones: string;
  cost_monthly: string;
  on_sale: string;
}

interface Props {
  items?: PlanData[];
  planDescription: any;
  planInfoText: any;
}

const TRIAL_URLS: string[] = [
  process.env.React_App_STARTTRIAL_BASIC || "",
  process.env.React_App_STARTTRIAL_PROFESSIONAL || "",
  process.env.React_App_STARTTRIAL_CORPORATE || "",
];

const Plan: React.FC<Props> = ({ items, planDescription, planInfoText }) => {
  return (
    <div className="plans-grid">
      {items &&
        items.map((plan, index) => (
          <PlanItems
            key={plan.id}
            name={plan.name}
            description={plan.description}
            provides={plan.provides}
            cost_ones={plan.cost_ones}
            cost_monthly={plan.cost_monthly}
            on_sale={plan.on_sale}
            trialUrl={TRIAL_URLS[index]}
            planDescription={planDescription}
            planInfoText={planInfoText}
            featured={index === 1}
            delay={index * 90}
          />
        ))}
    </div>
  );
};

export default Plan;
